// AUTO-GENERATED from packages/core/analytics/events.json. Do not edit.
// Regenerate: npm run analytics:generate

export type AnalyticsEventClass = "intent" | "system";

export interface AnalyticsEventDef {
  readonly name: string;
  readonly eventClass: AnalyticsEventClass;
  readonly surfaces: readonly string[];
  readonly allowedProps: readonly string[];
}

export const FORBIDDEN_PROP_KEYS = ["body", "package_name", "sender", "text", "title"] as const;

export const ANALYTICS_EVENTS = {
  agent_connect_started: {
    name: "agent_connect_started",
    eventClass: "intent",
    surfaces: ["android"],
    allowedProps: ["entry"],
  },
  analytics_opt_out_toggled: {
    name: "analytics_opt_out_toggled",
    eventClass: "intent",
    surfaces: ["android", "extension", "web"],
    allowedProps: ["enabled"],
  },
  app_first_open: {
    name: "app_first_open",
    eventClass: "intent",
    surfaces: ["android"],
    allowedProps: [],
  },
  app_lock_configured: {
    name: "app_lock_configured",
    eventClass: "intent",
    surfaces: ["android"],
    allowedProps: ["enabled", "timeout_bucket"],
  },
  app_update_accepted: {
    name: "app_update_accepted",
    eventClass: "intent",
    surfaces: ["android"],
    allowedProps: ["type"],
  },
  app_update_deferred: {
    name: "app_update_deferred",
    eventClass: "intent",
    surfaces: ["android"],
    allowedProps: ["type"],
  },
  app_update_failed: {
    name: "app_update_failed",
    eventClass: "intent",
    surfaces: ["android"],
    allowedProps: ["type"],
  },
  app_update_prompted: {
    name: "app_update_prompted",
    eventClass: "intent",
    surfaces: ["android"],
    allowedProps: ["type"],
  },
  clip_composer_sent: {
    name: "clip_composer_sent",
    eventClass: "intent",
    surfaces: ["android", "extension", "web"],
    allowedProps: ["target_scope"],
  },
  clip_copied_from_history: {
    name: "clip_copied_from_history",
    eventClass: "intent",
    surfaces: ["android", "extension", "web"],
    allowedProps: ["direction"],
  },
  clipboard_manager_opened: {
    name: "clipboard_manager_opened",
    eventClass: "intent",
    surfaces: ["android", "extension", "web"],
    allowedProps: [],
  },
  connected_app_registered: {
    name: "connected_app_registered",
    eventClass: "system",
    surfaces: ["server"],
    allowedProps: ["app_kind"],
  },
  connector_url_copied: {
    name: "connector_url_copied",
    eventClass: "intent",
    surfaces: ["android"],
    allowedProps: ["entry"],
  },
  daily_usage_rollup: {
    name: "daily_usage_rollup",
    eventClass: "system",
    surfaces: ["android", "extension", "web"],
    allowedProps: [
      "app_foreground_count",
      "app_opens",
      "apps_enabled_count",
      "dismissals_count",
      "glance_viewed_count",
      "mcp_notifications_received_count",
      "notifications_delivered_count",
      "notifications_relayed_count",
      "notifications_seen_count",
      "replies_sent_count",
      "rollup_date",
      "side_panel_opens",
      "sms_ledger_unordered_count",
      "sms_ledger_unreadable_count",
    ],
  },
  document_save_failed: {
    name: "document_save_failed",
    eventClass: "system",
    surfaces: ["android"],
    allowedProps: ["reason"],
  },
  document_saved: {
    name: "document_saved",
    eventClass: "system",
    surfaces: ["android"],
    allowedProps: [],
  },
  document_sent: {
    name: "document_sent",
    eventClass: "system",
    surfaces: ["server"],
    allowedProps: ["byte_length_bucket", "source"],
  },
  extension_installed: {
    name: "extension_installed",
    eventClass: "intent",
    surfaces: ["extension"],
    allowedProps: ["browser", "extension_version"],
  },
  file_transfer_cancelled: {
    name: "file_transfer_cancelled",
    eventClass: "system",
    surfaces: ["extension", "android", "web"],
    allowedProps: ["initiator", "role"],
  },
  file_transfer_completed: {
    name: "file_transfer_completed",
    eventClass: "system",
    surfaces: ["extension", "android", "web"],
    allowedProps: ["duration_bucket", "resumed", "role", "transport"],
  },
  file_transfer_demoted: {
    name: "file_transfer_demoted",
    eventClass: "system",
    surfaces: ["extension", "android"],
    allowedProps: ["pct_persisted", "role", "trigger"],
  },
  file_transfer_failed: {
    name: "file_transfer_failed",
    eventClass: "system",
    surfaces: ["extension", "android", "web"],
    allowedProps: ["error_code", "role", "stage"],
  },
  file_transfer_offer_responded: {
    name: "file_transfer_offer_responded",
    eventClass: "intent",
    surfaces: ["extension", "android", "web"],
    allowedProps: ["decision"],
  },
  file_transfer_started: {
    name: "file_transfer_started",
    eventClass: "intent",
    surfaces: ["extension", "android", "web"],
    allowedProps: ["size_bucket"],
  },
  first_dismiss: {
    name: "first_dismiss",
    eventClass: "intent",
    surfaces: ["extension", "web"],
    allowedProps: [],
  },
  first_glance_viewed: {
    name: "first_glance_viewed",
    eventClass: "intent",
    surfaces: ["extension", "web"],
    allowedProps: [],
  },
  first_light_received: {
    name: "first_light_received",
    eventClass: "system",
    surfaces: ["extension", "web"],
    allowedProps: [],
  },
  first_light_sent: {
    name: "first_light_sent",
    eventClass: "system",
    surfaces: ["android"],
    allowedProps: [],
  },
  first_notification_seen: {
    name: "first_notification_seen",
    eventClass: "intent",
    surfaces: ["extension", "web"],
    allowedProps: ["hours_since_pairing"],
  },
  first_reply_sent: {
    name: "first_reply_sent",
    eventClass: "intent",
    surfaces: ["extension", "web"],
    allowedProps: [],
  },
  glance_download_consented: {
    name: "glance_download_consented",
    eventClass: "intent",
    surfaces: ["extension", "web"],
    allowedProps: [],
  },
  glance_viewed: {
    name: "glance_viewed",
    eventClass: "intent",
    surfaces: ["extension", "web"],
    allowedProps: [],
  },
  home_quick_action: {
    name: "home_quick_action",
    eventClass: "intent",
    surfaces: ["android"],
    allowedProps: ["action"],
  },
  inbox_item_shared: {
    name: "inbox_item_shared",
    eventClass: "intent",
    surfaces: ["android"],
    allowedProps: ["kind"],
  },
  inbox_pulled: {
    name: "inbox_pulled",
    eventClass: "system",
    surfaces: ["server"],
    allowedProps: ["item_count"],
  },
  interaction_already_answered_tap: {
    name: "interaction_already_answered_tap",
    eventClass: "system",
    surfaces: ["server"],
    allowedProps: [],
  },
  interaction_answered: {
    name: "interaction_answered",
    eventClass: "system",
    surfaces: ["server"],
    allowedProps: ["latency_bucket"],
  },
  interaction_created: {
    name: "interaction_created",
    eventClass: "system",
    surfaces: ["server"],
    allowedProps: ["choice_count", "expires_bucket", "source"],
  },
  interaction_expired: {
    name: "interaction_expired",
    eventClass: "system",
    surfaces: ["server"],
    allowedProps: [],
  },
  local_mcp_active: {
    name: "local_mcp_active",
    eventClass: "system",
    surfaces: ["server"],
    allowedProps: [],
  },
  mcp_send_notification_called: {
    name: "mcp_send_notification_called",
    eventClass: "system",
    surfaces: ["server"],
    allowedProps: ["app_kind", "rate_limited", "status"],
  },
  nav_tab_selected: {
    name: "nav_tab_selected",
    eventClass: "intent",
    surfaces: ["android"],
    allowedProps: ["tab"],
  },
  onboarding_check_continued: {
    name: "onboarding_check_continued",
    eventClass: "intent",
    surfaces: ["android"],
    allowedProps: ["outcome"],
  },
  onboarding_step_completed: {
    name: "onboarding_step_completed",
    eventClass: "intent",
    surfaces: ["android"],
    allowedProps: ["step"],
  },
  pairing_code_displayed: {
    name: "pairing_code_displayed",
    eventClass: "intent",
    surfaces: ["extension", "web"],
    allowedProps: [],
  },
  pairing_code_entry_started: {
    name: "pairing_code_entry_started",
    eventClass: "intent",
    surfaces: ["android"],
    allowedProps: [],
  },
  pairing_completed: {
    name: "pairing_completed",
    eventClass: "intent",
    surfaces: ["android", "extension", "web"],
    allowedProps: ["intent", "time_to_pair_s"],
  },
  pairing_failed: {
    name: "pairing_failed",
    eventClass: "intent",
    surfaces: ["android"],
    allowedProps: ["reason"],
  },
  pairing_lost: {
    name: "pairing_lost",
    eventClass: "system",
    surfaces: ["android", "extension", "web"],
    allowedProps: ["trigger"],
  },
  pairing_removed: {
    name: "pairing_removed",
    eventClass: "intent",
    surfaces: ["android"],
    allowedProps: [],
  },
  pairing_started: {
    name: "pairing_started",
    eventClass: "intent",
    surfaces: ["android"],
    allowedProps: [],
  },
  palette_command_executed: {
    name: "palette_command_executed",
    eventClass: "intent",
    surfaces: ["extension", "web"],
    allowedProps: ["command_id"],
  },
  palette_opened: {
    name: "palette_opened",
    eventClass: "intent",
    surfaces: ["extension", "web"],
    allowedProps: [],
  },
  panel_window_mode_changed: {
    name: "panel_window_mode_changed",
    eventClass: "intent",
    surfaces: ["extension"],
    allowedProps: ["enabled"],
  },
  panel_window_opened: {
    name: "panel_window_opened",
    eventClass: "intent",
    surfaces: ["extension"],
    allowedProps: ["source"],
  },
  queue_expired_unconsumed: {
    name: "queue_expired_unconsumed",
    eventClass: "system",
    surfaces: ["server"],
    allowedProps: ["device_kind", "expired_count", "reason"],
  },
  rating_link_opened: {
    name: "rating_link_opened",
    eventClass: "intent",
    surfaces: ["android", "extension"],
    allowedProps: ["placement", "store"],
  },
  rating_prompt_attempted: {
    name: "rating_prompt_attempted",
    eventClass: "intent",
    surfaces: ["android"],
    allowedProps: [],
  },
  rating_request_failed: {
    name: "rating_request_failed",
    eventClass: "system",
    surfaces: ["android"],
    allowedProps: ["error_code"],
  },
  reminder_cancelled: {
    name: "reminder_cancelled",
    eventClass: "system",
    surfaces: ["server"],
    allowedProps: ["source"],
  },
  reminder_created: {
    name: "reminder_created",
    eventClass: "system",
    surfaces: ["server"],
    allowedProps: ["lead_bucket", "source"],
  },
  reminder_fired: {
    name: "reminder_fired",
    eventClass: "system",
    surfaces: ["android"],
    allowedProps: [],
  },
  ring_commanded: {
    name: "ring_commanded",
    eventClass: "system",
    surfaces: ["server"],
    allowedProps: ["source"],
  },
  ring_completed: {
    name: "ring_completed",
    eventClass: "intent",
    surfaces: ["android"],
    allowedProps: ["stopped_by"],
  },
  safety_number_viewed: {
    name: "safety_number_viewed",
    eventClass: "intent",
    surfaces: ["android", "extension", "web"],
    allowedProps: [],
  },
  security_alert_opened: {
    name: "security_alert_opened",
    eventClass: "intent",
    surfaces: ["android"],
    allowedProps: [],
  },
  security_alert_sent: {
    name: "security_alert_sent",
    eventClass: "system",
    surfaces: ["server", "android"],
    allowedProps: ["channel"],
  },
  server_throughput_tick: {
    name: "server_throughput_tick",
    eventClass: "system",
    surfaces: ["server"],
    allowedProps: ["fcm_command_dropped_count", "messages_relayed_count"],
  },
  side_panel_opened: {
    name: "side_panel_opened",
    eventClass: "intent",
    surfaces: ["extension"],
    allowedProps: [],
  },
  sms_disabled: {
    name: "sms_disabled",
    eventClass: "intent",
    surfaces: ["android"],
    allowedProps: [],
  },
  sms_enable_outcome: {
    name: "sms_enable_outcome",
    eventClass: "intent",
    surfaces: ["android"],
    allowedProps: ["outcome"],
  },
  sms_enable_started: {
    name: "sms_enable_started",
    eventClass: "intent",
    surfaces: ["android"],
    allowedProps: [],
  },
  sms_initial_sync_completed: {
    name: "sms_initial_sync_completed",
    eventClass: "system",
    surfaces: ["android"],
    allowedProps: ["outcome"],
  },
  solo_registration_completed: {
    name: "solo_registration_completed",
    eventClass: "intent",
    surfaces: ["android"],
    allowedProps: [],
  },
  solo_registration_failed: {
    name: "solo_registration_failed",
    eventClass: "intent",
    surfaces: ["android"],
    allowedProps: ["reason"],
  },
  solo_registration_started: {
    name: "solo_registration_started",
    eventClass: "intent",
    surfaces: ["android"],
    allowedProps: [],
  },
  store_cta_clicked: {
    name: "store_cta_clicked",
    eventClass: "intent",
    surfaces: ["landing"],
    allowedProps: ["placement", "store"],
  },
  sync_fallback_served: {
    name: "sync_fallback_served",
    eventClass: "system",
    surfaces: ["server"],
    allowedProps: ["device_kind", "items_bucket"],
  },
  token_sent_to_computer: {
    name: "token_sent_to_computer",
    eventClass: "intent",
    surfaces: ["android"],
    allowedProps: [],
  },
  web_app_first_open: {
    name: "web_app_first_open",
    eventClass: "intent",
    surfaces: ["web"],
    allowedProps: [],
  },
  web_app_opened: {
    name: "web_app_opened",
    eventClass: "intent",
    surfaces: ["web"],
    allowedProps: [],
  },
} as const satisfies Record<string, AnalyticsEventDef>;

export type AnalyticsEventName = keyof typeof ANALYTICS_EVENTS;

// Public write-only ingestion key (phc_) — safe to ship in clients by design.
// Personal API keys (phx_) must NEVER appear anywhere in this repo.
export const POSTHOG_HOST = "https://us.i.posthog.com";
export const POSTHOG_PROJECT_KEY = "phc_vecuXfyEQdErsdKdqByoxscsGWMTEARS2CyLXztnxsgR";

export interface SanitizedEvent {
  name: string;
  properties: Record<string, unknown>;
}

/**
 * Builds the only payload shape a platform wrapper may hand to a PostHog SDK.
 * Allowlists properties from the registry (unknown keys are dropped, never
 * sent), strips forbidden keys and `$ip` as defense in depth, and stamps the
 * registry's `event_class` so a call site can never omit or fake it.
 */
export function buildEventPayload(
  event: AnalyticsEventName,
  props: Record<string, unknown> = {}
): SanitizedEvent {
  const def = ANALYTICS_EVENTS[event];
  const properties: Record<string, unknown> = {};
  for (const key of def.allowedProps) {
    const value = props[key];
    if (value !== undefined) properties[key] = value;
  }
  for (const key of FORBIDDEN_PROP_KEYS) delete properties[key];
  delete properties.$ip;
  properties.event_class = def.eventClass;
  return { name: def.name, properties };
}
